export default __webpack_public_path__ + "static/media/Business-Intelligence-EN.bb2c96e5.jpg";